import {
  combineTranslationBundles,
  loadPackageTranslations,
  Localization,
  setupTranslationLanguageSync,
  type LanguageCode
} from '@hconnect/common/localization-loaders'
import {uikitTranslations} from '@hconnect/uikit'
import i18n from 'i18next'

export const supportedLngs: LanguageCode[] = [
  'en-US',
  'en-GB',
  'de-DE',
  'ru-RU',
  'it-IT',
  'fr-FR',
  'cs-CZ',
  'hu-HU',
  'nl-NL',
  'sv-SE',
  'es-ES',
  'ro-RO',
  'no-NO',
  'pl-PL'
]

const isDev = process.env.NODE_ENV === 'development'

const loader = async (filename: string) => {
  if (isDev) {
    console.info(`Load Translation for HProduce Suite [${filename}]`)
  }
  try {
    return (await import(`./${filename}`)).default
  } catch (err) {
    if (isDev) {
      console.error(`Could not load Translation [${filename}]`, err)
    }
    return {err}
  }
}

const externalPackageTranslations = combineTranslationBundles([uikitTranslations])

export async function initLocalization() {
  await Localization({
    supportedLngs,
    backend: {loader},
    debug: isDev,
    fallbackLng: 'en-GB',
    detection: {
      order: ['localStorage', 'cookie', 'navigator']
    },
    returnEmptyString: false,
    compatibilityJSON: undefined,
    load: 'currentOnly'
  }).then(() => {
    void loadPackageTranslations(i18n, externalPackageTranslations, {debug: isDev})
    setupTranslationLanguageSync(i18n, externalPackageTranslations, {debug: isDev})
  })
}
